import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export interface UserCreateRequestParams {
  email: string;
  password: string;
  role: number;
}

export interface UserUpdateRequestParams {
  id: number;
  role: number;
}

export interface UserSetPasswordRequestParams {
  id: number;
  password: string;
}

export interface UserDeleteRequestParams {
  id: number;
}

export class UserClient {
  constructor(private httpClient: HTTPClient) {}

  public async postUsers(params: UserCreateRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/users",
      method: "POST",
      data: params
    });

    return data;
  }

  public async getUsers(params: PaginationRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/users",
      method: "GET",
      params
    });

    return data;
  }

  public async getUser(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/users/${id}`,
      method: "GET"
    });

    return data;
  }

  public async patchUsers(params: UserUpdateRequestParams): Promise<any> {
    const { id, ...body } = params;
    const { data } = await this.httpClient.request({
      url: `/users/${id}`,
      method: "PATCH",
      data: body
    });

    return data;
  }

  public async patchSetPassword(
    params: UserSetPasswordRequestParams
  ): Promise<any> {
    const { id, ...body } = params;
    const { data } = await this.httpClient.request({
      url: `/users/${id}/set-password`,
      method: "PATCH",
      data: body
    });

    return data;
  }

  public async deleteUsers(params: UserDeleteRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/users/${params.id}`,
      method: "DELETE"
    });

    return data;
  }
}
